import React from "react";
import { Box, Button, Chip } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import {
  MRT_ToggleFiltersButton as MrTableToggleFiltersButton,
  MRT_ShowHideColumnsButton as MrTableShowHideColumnsButton,
} from "material-react-table";
import TableSearchWithField from "../TableSearchWithField/TableSearchWithField.jsx";
import { exportTableToCsv } from "../../Utils/exportTableToCsv.js";

export default function TableToolbarWithSearch({
  table,
  chips = [],
  searchFieldOptions,
  searchField,
  onSearchFieldChange,
  globalFilter,
  onGlobalFilterChange,
  selectMinWidth = 100,
  action,
  exportFileName,
}) {
  const exportOptions = React.useMemo(() => {
    const name = String(exportFileName || '').toLowerCase();

    if (name === 'members') {
      return {
        preferredKeys: ['firstName', 'lastName'],
        keyMap: { firstName: 'name', lastName: 'surname' },
        omitKeys: ['name', 'surname'],
      };
    }
    if (name === 'speakers' || name === 'guests') {
      return {
        preferredKeys: ['firstName', 'lastName'],
      };
    }
    if (name === 'events' || name === 'partnerships' || name === 'news') {
      return {
        preferredKeys: ['title'],
      };
    }
    return undefined;
  }, [exportFileName]);

  const handleExport = () => {
    const done = exportTableToCsv(table, exportFileName || "export", exportOptions);
    if (!done) {
      alert("No data to export.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        p: "4px",
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          variant={chip.active ? "filled" : "outlined"}
          label={chip.label}
          onClick={chip.onClick}
        />
      ))}
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <TableSearchWithField
          options={searchFieldOptions}
          searchField={searchField}
          onSearchFieldChange={onSearchFieldChange}
          globalFilter={globalFilter}
          onGlobalFilterChange={onGlobalFilterChange}
          selectMinWidth={selectMinWidth}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Button
          size="small"
          startIcon={<FileDownload />}
          onClick={handleExport}
        >
          Export CSV
        </Button>
        <MrTableToggleFiltersButton table={table} />
        <MrTableShowHideColumnsButton table={table} />
        {action}
      </Box>
    </Box>
  );
}

